import React from "react";
import { Input } from "@/components/ui/input";
import DefaultedSaleCard from "@/components/sales/DefaultedSaleCard";
import { useSalesAndPayments } from "@/context/SalesAndPaymentsContext";

export default function DefaultedTab() {
  const ctx = useSalesAndPayments();
  const {
    canEdit,
    defaultedSales,
    filteredDefaultedSales,
    salesSearchQuery,
    setSalesSearchQuery,
    getClient,
    getApartment,
    handleDeleteDefaultedSale,
  } = ctx;

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <div className="flex gap-3 text-sm">
          <span className="px-3 py-1 bg-red-100 text-red-700 rounded-full font-medium">
            {defaultedSales.length} Defaulted
          </span>
        </div>
        {canEdit && (
          <div className="flex gap-3">
            <Input
              placeholder="Search defaulted sales..."
              className="w-64"
              value={salesSearchQuery}
              onChange={(e) => setSalesSearchQuery(e.target.value)}
            />
          </div>
        )}
      </div>
      <div className="grid gap-4 grid-cols-1">
        {filteredDefaultedSales.length === 0 ? (
          <div className="col-span-full text-center py-10 text-slate-500">
            No defaulted sales found.
          </div>
        ) : (
          filteredDefaultedSales.map((sale) => (
            <DefaultedSaleCard
              key={sale.id}
              sale={sale}
              client={getClient(sale.client_id)}
              apartment={getApartment(sale.apartment_id)}
              onDelete={
                canEdit ? () => handleDeleteDefaultedSale(sale) : undefined
              }
            />
          ))
        )}
      </div>
    </div>
  );
}